export default {
  methods: {
    formatterType (r, b, c) {
      switch (c) {
        case 1: return '单选题'
        case 2: return '多选题'
        case 3: return '判断题'
        case 4: return '排序题'
        case 5: return '填空题'
      }
    },
    formatterLevel (r, b, c) {
      switch (c) {
        case 0: return '容易'
        case 1: return '中等'
        case 2: return '困难'
      }
    },
    formattervedioType (r, b, c) {
      switch (c) {
        case 0: return '理论知识'
        case 1: return '读片知识'
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixin/formatter.js